export function arrayWrap(min: number, max: number, current: number): number {
  const range = max - min;
  const currentDiff = current - min;
  return min + (((currentDiff % range) + range) % range);
}
